import styled from 'styled-components'
import { Table } from 'react-bootstrap'

export const SolicitationsTableWrapper = styled.div`
  width: 100%;
  border: 1px solid var(--primary, #0072bc);
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
`

export const SolicitationsTableScroll = styled.div`
  overflow-x: auto;
  width: 100%;
`

export const SolicitationsTable = styled(Table)`
  && {
    margin-bottom: 0;
    border: none;

    thead th {
      border: none;
      border-bottom: 1px solid var(--primary, #0072bc);
      color: var(--primary, #0072bc);
      font-size: 16px;
      font-weight: 400;
      line-height: 140%;
      padding: 12px 16px;
      background: #fff;
      white-space: nowrap;

      &:last-child {
        text-align: right;
      }
    }

    tbody tr {
      background: #fff;
      border-bottom: 1px solid #e5e7eb;

      &:last-child {
        border-bottom: none;
      }

      td {
        border: none;
        color: #464646;
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
        padding: 12px 16px;
        vertical-align: middle;
        background: #fff;

        &:last-child {
          text-align: right;
        }
      }
    }
  }
`

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  white-space: nowrap;

  ${({ $status }) => {
    switch ($status) {
      case 'pendente':
        return `
          background: #ffe7d1;
          color: #a95100;
        `
      case 'aprovada':
        return `
          background: #dcffe0;
          color: #219d1d;
        `
      case 'reprovada':
        return `
          background: #f8d7da;
          color: #721c24;
        `
      case 'cancelada':
        return `
          background: #e9ecef;
          color: #495057;
        `
      default:
        return `
          background: #f0f0f0;
          color: #464646;
        `
    }
  }}
`

export const RequesterLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #464646;
  font-size: inherit;
  font-weight: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: var(--primary, #0072bc);
  }
`

export const EmptyTableMessage = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #6c757d;
  font-size: 0.95rem;
`
